import { Component, OnInit } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { FormGroup } from '@angular/forms';
import { DomainsService } from '../services/domains.service';
import { Domain } from '../interfaces/domain.model';

@Component({
  selector: 'app-domain-list',
  templateUrl: './domain-list.component.html'
})
export class DomainListComponent implements OnInit {

  public domainNameValue: String = '';
  public domains: Array<Domain> = [];

  public domainForm: FormGroup;

  public loadingDomains: Boolean = true;
  public domain: Domain = null;


  constructor(
    private notificationsService: NotificationsService,
    private domainsService: DomainsService,
  ) {

  }

  /**
   * 
   * @memberof DomainListComponent
   */
  ngOnInit() {
    this.loadDomains();
  }

  public loadDomains() {
    this.loadingDomains = true;
    this.domainsService.getAllCompanyDomains().subscribe(
      (domains) => {
        this.domains = domains as Array<Domain>;
        this.loadingDomains = false;
      },
      (error) => {
        this.notificationsService.success('Ups!', 'Błąd przy pobieraniu listy domen');
        this.loadingDomains = false;
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/domain/domain-list.component.ts